/**
 * Flux UI class recipes ported for React (@hp/ui).
 * Light theme only — matches livewire/flux outline inputs, buttons, and surfaces.
 */
export const fluxSurfaceBorder = "border border-zinc-200 border-b-zinc-300/80";
export const fluxInputOutline = [
    "w-full appearance-none bg-white text-zinc-700 placeholder-zinc-400",
    "disabled:text-zinc-500 disabled:placeholder-zinc-400/70 disabled:shadow-none",
    "shadow-xs",
    fluxSurfaceBorder,
    "data-[invalid=true]:border-red-500 data-[invalid=true]:shadow-none",
].join(" ");
export const fluxInputSizes = {
    base: "h-10 rounded-lg px-3 text-base sm:text-sm leading-[1.375rem]",
    sm: "h-8 rounded-md px-3 text-sm leading-[1.125rem]",
    xs: "h-6 rounded-md px-2 text-xs leading-[1.125rem]",
};
export function resolveButtonVariant(variant) {
    if (variant === "secondary")
        return "outline";
    return variant;
}
export const fluxButtonBase = [
    "relative inline-flex items-center justify-center whitespace-nowrap font-medium",
    "disabled:cursor-default disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none",
].join(" ");
export const fluxButtonSizes = {
    base: "h-10 gap-2 rounded-lg px-4 text-sm",
    sm: "h-8 gap-2 rounded-md px-3 text-sm",
    xs: "h-6 gap-1 rounded-md px-2 text-xs",
};
export const fluxButtonSquareSizes = {
    base: "h-10 w-10 rounded-lg",
    sm: "h-8 w-8 rounded-md",
    xs: "h-6 w-6 rounded-md",
};
export const fluxButtonVariants = {
    primary: [
        "border border-black/10 bg-[var(--color-accent)] text-[var(--color-accent-foreground)]",
        "hover:bg-[color-mix(in_oklab,var(--color-accent),transparent_10%)]",
        "shadow-[inset_0px_1px_rgba(255,255,255,0.2)]",
    ].join(" "),
    filled: "bg-zinc-800/5 text-zinc-800 hover:bg-zinc-800/10",
    outline: [
        "border border-zinc-200 border-b-zinc-300/80 bg-white text-zinc-800 shadow-xs",
        "hover:bg-zinc-50 hover:border-zinc-200 disabled:border-zinc-200",
    ].join(" "),
    ghost: "bg-transparent text-zinc-800 hover:bg-zinc-800/5",
    subtle: "bg-transparent text-zinc-500 hover:bg-zinc-800/5 hover:text-zinc-800",
    danger: [
        "bg-red-500 text-white hover:bg-red-600",
        "shadow-[inset_0px_1px_var(--color-red-500),inset_0px_2px_rgba(255,255,255,0.15)]",
    ].join(" "),
};
export const fluxCardSurface = "rounded-xl bg-white shadow-xs ring-1 ring-black/[0.07]";
export const fluxComposerSurface = [
    "rounded-2xl bg-white p-2 shadow-xs",
    fluxSurfaceBorder,
].join(" ");
export const fluxBadgeColors = {
    zinc: "text-zinc-700 bg-zinc-400/15",
    sky: "text-sky-800 bg-sky-400/20",
    amber: "text-amber-800 bg-amber-400/25",
    emerald: "text-emerald-800 bg-emerald-400/20",
    red: "text-red-700 bg-red-400/20",
};
